import type { SortDirectionType } from '@rio-cloud/rio-uikit/SortDirection';
import type { UnknownAction } from '@reduxjs/toolkit';
import type { ThunkDispatch } from 'redux-thunk';
import type { RootState } from '../../../configuration/setup/store';
import { driverIdSchema, driversSortFieldNameSchema, driverStatusFilterSchema, validate } from '../schema';
import { reportErrorToSentry } from '../../../configuration/setup/sentry';
import type { DriverStatus } from '../../../types';
import { driverSelected, driverStatusesChanged, sortChanged } from '../appSlice';
import { clearAllTags } from '../drivers/sidebar/tabs/groups/groupSlice';
import { setSelectedDriver } from '../drivers/sidebar/sidebarSlice';
import { getDriversRtk } from '../appSlice';

export const selectDriver = (_oldDriverId: string | undefined, driverId: string) => {
    const result = validate(driverIdSchema, driverId);
    if (!result.success) {
        reportErrorToSentry(result.error);
    }

    return (dispatch: ThunkDispatch<RootState, unknown, UnknownAction>, getState?: () => RootState) => {
        dispatch(driverSelected(driverId));
        const selectedDriver = getState
            ? getDriversRtk(getState()).find(driver => driver.driverId === driverId) ?? null
            : null;
        dispatch(setSelectedDriver(selectedDriver));
        dispatch(clearAllTags());
    };
};

export const sortDrivers = (
    sortBy: string,
    sortDir?: SortDirectionType
): ((dispatch: ThunkDispatch<RootState, unknown, UnknownAction>) => void) => {
    const result = validate(driversSortFieldNameSchema, sortBy);
    if (!result.success) {
        reportErrorToSentry(result.error);
    }

    return (dispatch: ThunkDispatch<RootState, unknown, UnknownAction>) => {
        dispatch(sortChanged({ sortBy, sortDir }));
    };
};

export const changeDriverStatuses = (driverStatuses: DriverStatus[]) => {
    const result = validate(driverStatusFilterSchema, driverStatuses);
    if (!result.success) {
        reportErrorToSentry(result.error);
    }

    return (dispatch: ThunkDispatch<RootState, unknown, UnknownAction>) => {
        dispatch(driverStatusesChanged(driverStatuses));
    };
};
